module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.length || _vm.data.length === 1 && _vm.data[0]),
      expression: "data.length || data.length === 1 && data[0]"
    }],
    staticClass: "qrcode-view",
    class: [_vm.paddingTop ? 'qrcode-view-top' : '']
  }, [(_vm.data.length > 1) ? _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.data), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "swiper-slide"
    }, [_c('a', {
      attrs: {
        "href": 'javascript:'
      }
    }, [_c('img', {
      attrs: {
        "src": item.image,
        "data-url": item.url,
        "data-id": item.id
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]) : _vm._e(), _vm._v(" "), (_vm.data.length === 1 && _vm.data[0]) ? _c('a', {
    attrs: {
      "href": 'javascript:'
    },
    on: {
      "click": function($event) {
        return _vm.onItem(_vm.data[0])
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.data[0].image
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e83991b8","hasScoped":true,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ad.vue
// module id = eA1R
// module chunks = 2